import API_BASE_URL from '../Config';

const API_URL = `${API_BASE_URL}/categorias`;

export const getCategorias = async (token) => {
    const response = await fetch(API_URL, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar categorías');
    return response.json();
};

export const getCategoriaById = async (token, id) => {
    const response = await fetch(`${API_URL}/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al obtener categoría');
    return response.json();
};
